<template>
  <v-layout>
    <Header
      @toggleMenu="drawer = !drawer"
      :isShowSideMenu="isShowSideMenu"
      :isFromRevampPath="isFromRevampPath"
    />
    <SideMenu
      v-if="isShowSideMenu"
      v-model="drawer"
      :rail-width="296"
      :rail="true"
      :drawer="drawer"
      :namaType="namaType"
      :isFromRevampPath="isFromRevampPath"
      @close="drawer = false"
    />
    <v-main>
      <div class="max-w-[1200px] mx-auto">
        <div class="px-[16px] mb-[80px] min-h-screen">
          <Breadcrumb />
          <div class="mt-5 sm:mt-8 mb-20 sm:mb-24 lg:mb-32">
            <NuxtPage />
          </div>
        </div>
      </div>
      <Footer
    /></v-main>
  </v-layout>
</template>

<script setup>
import Header from "~/components/revamp/Header.vue";
import Footer from "~/components/revamp/Footer.vue";
import SideMenu from "~/components/revamp/SideMenu.vue";
import Breadcrumb from "~/components/revamp/Breadcrumb.vue";

const drawer = ref(true);

const namaType = computed(() => {
  const courseData = useBelajarWajibReaderStore().filteredCourseData || {};
  const angkatan = courseData.angkatan || {};
  return angkatan.masterTypes?.namaType || "";
});

const route = ref(useRoute());

const eligiblePaths = [
  "/portal-pembelajaran/orientasi-PPPK/**",
  "/portal-pembelajaran/swajar-PPPK/**",
  "/portal-pembelajaran/swajar-CPNS/**",
  "/portal-pembelajaran/terjadwal/**",
  "/revamp/portal-pembelajaran/orientasi-PPPK/**",
  "/revamp/portal-pembelajaran/swajar-PPPK/**",
  "/revamp/portal-pembelajaran/swajar-CPNS/**",
  "/revamp/portal-pembelajaran/terjadwal/**",
];

const isShowSideMenu = computed(() => {
  return eligiblePaths.some((path) => {
    if (path.includes("**")) {
      const basePath = path.replace("/**", "");
      return route.value.path.startsWith(basePath);
    }
    return route.value.path === path;
  });
});

const isFromRevampPath = computed(() => {
  return /revamp/.test(route.value.path);
});
</script>
<style>
.ina-modal {
  z-index: 9999 !important;
}
</style>
